import { render, staticRenderFns } from "./fontSizeControler.vue?vue&type=template&id=223f5b74&scoped=true"
import script from "./fontSizeControler.vue?vue&type=script&lang=js"
export * from "./fontSizeControler.vue?vue&type=script&lang=js"
import style0 from "./fontSizeControler.vue?vue&type=style&index=0&id=223f5b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f5b74",
  null
  
)

export default component.exports